import type { AxiosInstance } from 'axios'
import { request } from '../client'
import type {
  TCortexTenant,
  TCortexTenantList,
  TCortexTenantCreateRequest,
  TCortexGrant,
  TCortexGrantList,
  TCortexGrantCreateRequest,
} from '../types/staff'

export interface CortexTenantsApi {
  list: () => Promise<TCortexTenantList>
  get: (id: string) => Promise<TCortexTenant>
  create: (req: TCortexTenantCreateRequest) => Promise<TCortexTenant>
  delete: (id: string) => Promise<void>

  listGrants: (tenantId: string) => Promise<TCortexGrantList>
  createGrant: (req: TCortexGrantCreateRequest) => Promise<TCortexGrant>
  revokeGrant: (grantId: number) => Promise<void>
}

export function createCortexTenantsApi(api: AxiosInstance): CortexTenantsApi {
  const base = '/staff/cortex/tenants'
  return {
    list: () =>
      request<TCortexTenantList>(api, { method: 'GET', url: base }),
    get: (id) =>
      request<TCortexTenant>(api, { method: 'GET', url: `${base}/${encodeURIComponent(id)}` }),
    create: (req) =>
      request<TCortexTenant>(api, { method: 'POST', url: base, data: req }),
    delete: (id) =>
      request<void>(api, { method: 'DELETE', url: `${base}/${encodeURIComponent(id)}` }),

    listGrants: (tenantId) =>
      request<TCortexGrantList>(api, { method: 'GET', url: `${base}/${encodeURIComponent(tenantId)}/grants` }),
    createGrant: (req) =>
      request<TCortexGrant>(api, { method: 'POST', url: `${base}/${encodeURIComponent(req.tenant_id)}/grants`, data: req }),
    revokeGrant: (grantId) =>
      request<void>(api, { method: 'DELETE', url: `/staff/cortex/grants/${grantId}` }),
  }
}
